/**
 * @file
 * @author dailin01
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { tuple } from '../_util/type';
import { ConfigConsumer } from '../config-provider';
const ButtonGroupTypes = tuple('default', 'primary', 'enhance');
const ButtonGroup = props => (<ConfigConsumer>
        {({ getPrefixCls }) => {
        const { prefixCls: customizePrefixCls } = props, restProps = __rest(props, ["prefixCls"]);
        const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
        return (<div className={prefixCls} {...restProps}/>);
    }}
    </ConfigConsumer>);
export default ButtonGroup;
